import { Component, Input, ViewEncapsulation } from '@angular/core';
import { WorkItem } from 'common/workitems/interfaces/workitem-base.interface';

@Component({
  selector: 'app-work-item-widget',
  templateUrl: './work-item-widget.component.html',
  styleUrls: ['./work-item-widget.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class WorkItemWidgetComponent {
  @Input()
  public workItem: WorkItem;
}
